<template>
	<a id="logo-lien-header" :href="coolocBaseURL" class="menu-logo" title="Retour à la page d'accueil">
    <img src="/static/images/logos/Cooloc-Logo.svg" alt="Logo COOLOC" />
  </a>
</template>

<script>
import { registrationHelpers } from '@/main'
export default {
  data: () => ({ user: null }),
  computed: {
    coolocBaseURL() { return process.env.VUE_APP_COOLOC_BASE_URL },
  },
  mounted() {
    registrationHelpers.fetchDataUser(this, null, true)
  },
}
</script>
